import {Module} from 'vuex';
import {RootState} from '@/types';
import AdminAPI from '@/api/AdminAPI';
import {SET_ADMIN, SET_ADMINS} from '@/store/mutationTypes';
import {namespace} from 'vuex-class';

export const adminModule = namespace('admins');

export interface Admin {
  [key: string]: any;
}

interface AdminState {
  admins: Admin[];
  admin: Admin | null;
}

export default <Module<AdminState, RootState>>{
  namespaced: true,
  state: {
    admins: [],
    admin: null,
  },
  mutations: {
    [SET_ADMINS](state, data) {
      state.admins = data;
    },
    [SET_ADMIN](state, data) {
      state.admin = data;
    },
  },
  actions: {
    async detail({commit}, id) {
      try {
        const {data} = await AdminAPI.detail(id);
        commit(SET_ADMIN, data.data);
        return data;
      } catch (e) {
        return e.response.data;
      }
    },
    async update(_, {id, data: payload}) {
      try {
        const {data} = await AdminAPI.update(id, payload);
        return data;
      } catch (e) {
        return e.response;
      }
    },
  },
  getters: {},
};
